import { useCallback, useEffect } from "react";
import { useRouter } from "next/router";

import clsx from "clsx";

import ApiError from "api/Error";

import Button from "ui-components/Button";
import Divider from "ui-components/Divider";

import { useCheckDataFileListingNonEmpty } from "modules/data-files/api";

import { FLOW_NAME } from "flows/sales-effectiveness/config";
import { useGetCreate } from "./api";

import {
  useInputFile,
  useGetSuccessDef,
  useGetCreateStatus,
  useGetCreateError,
  useResetStatus,
} from "./store";

import SelectData from "./Select-Data";
import OutcomeSelector from "./Define-Success";

const CreateProject = () => {
  const router = useRouter();
  const data = router.query.data as string;
  const { push, pathname } = router;

  const reset = useResetStatus();

  useEffect(() => {
    reset();
  }, []);

  const [, setCurrentFile] = useInputFile();
  const successDef = useGetSuccessDef();
  const createProject = useGetCreate();
  const submitStatus = useGetCreateStatus();
  const error = useGetCreateError();

  const successDefSet = successDef.length >= 1;

  useEffect(() => {
    if (data) {
      setCurrentFile(data);
    }
  }, [data, pathname]);

  const create = useCallback(async () => {
    const resp = await createProject();
    if (resp?.success) {
      push(`/${FLOW_NAME}/${resp.project.id}`);
    }
  }, [createProject, push]);

  const dataFilesPresent = useCheckDataFileListingNonEmpty();

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <div className="pb-4 mb-8">
        <h1 className="h2 text-center">Start Sales Effectiveness Analysis</h1>
      </div>
      <SelectData />
      {dataFilesPresent && (
        <>
          <Divider />
          <OutcomeSelector />
          {submitStatus === "completed" && error && <ApiError error={error} />}
          <div className="w-full px-3 my-4 py-4">
            <Button
              className={clsx(
                "w-full text-gray-100",
                successDefSet ? "bg-indigo-600" : "bg-indigo-400"
              )}
              disabled={!successDefSet}
              loading={submitStatus === "in-progress"}
              onClick={create}
            >
              {submitStatus === "in-progress"
                ? "Creating..."
                : "Create New Project"}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default CreateProject;
